import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import MonotoneChainIndexer from './MonotoneChainIndexer';
import Envelope from '../../geom/Envelope';
var MonotoneChainEdge = /*#__PURE__*/function () {
  function MonotoneChainEdge() {
    _classCallCheck(this, MonotoneChainEdge);
    MonotoneChainEdge.constructor_.apply(this, arguments);
  }
  _createClass(MonotoneChainEdge, [{
    key: "getCoordinates",
    value: function getCoordinates() {
      return this.pts;
    }
  }, {
    key: "getMaxX",
    value: function getMaxX(chainIndex) {
      var x1 = this.pts[this.startIndex[chainIndex]].x;
      var x2 = this.pts[this.startIndex[chainIndex + 1]].x;
      return x1 > x2 ? x1 : x2;
    }
  }, {
    key: "getMinX",
    value: function getMinX(chainIndex) {
      var x1 = this.pts[this.startIndex[chainIndex]].x;
      var x2 = this.pts[this.startIndex[chainIndex + 1]].x;
      return x1 < x2 ? x1 : x2;
    }
  }, {
    key: "computeIntersectsForChain",
    value: function computeIntersectsForChain() {
      if (arguments.length === 4) {
        var chainIndex0 = arguments[0],
          mce = arguments[1],
          chainIndex1 = arguments[2],
          si = arguments[3];
        this.computeIntersectsForChain(this.startIndex[chainIndex0], this.startIndex[chainIndex0 + 1], mce, mce.startIndex[chainIndex1], mce.startIndex[chainIndex1 + 1], si);
      } else if (arguments.length === 6) {
        var start0 = arguments[0],
          end0 = arguments[1],
          _mce = arguments[2],
          start1 = arguments[3],
          end1 = arguments[4],
          ei = arguments[5];
        if (end0 - start0 === 1 && end1 - start1 === 1) {
          ei.addIntersections(this.e, start0, _mce.e, start1);
          return null;
        }
        if (!this.overlaps(start0, end0, _mce, start1, end1)) return null;
        var mid0 = Math.trunc((start0 + end0) / 2);
        var mid1 = Math.trunc((start1 + end1) / 2);
        if (start0 < mid0) {
          if (start1 < mid1) this.computeIntersectsForChain(start0, mid0, _mce, start1, mid1, ei);
          if (mid1 < end1) this.computeIntersectsForChain(start0, mid0, _mce, mid1, end1, ei);
        }
        if (mid0 < end0) {
          if (start1 < mid1) this.computeIntersectsForChain(mid0, end0, _mce, start1, mid1, ei);
          if (mid1 < end1) this.computeIntersectsForChain(mid0, end0, _mce, mid1, end1, ei);
        }
      }
    }
  }, {
    key: "overlaps",
    value: function overlaps(start0, end0, mce, start1, end1) {
      return Envelope.intersects(this.pts[start0], this.pts[end0], mce.pts[start1], mce.pts[end1]);
    }
  }, {
    key: "getStartIndexes",
    value: function getStartIndexes() {
      return this.startIndex;
    }
  }, {
    key: "computeIntersects",
    value: function computeIntersects(mce, si) {
      for (var i = 0; i < this.startIndex.length - 1; i++) for (var j = 0; j < mce.startIndex.length - 1; j++) this.computeIntersectsForChain(i, mce, j, si);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this.e = null;
      this.pts = null;
      this.startIndex = null;
      var e = arguments[0];
      this.e = e;
      this.pts = e.getCoordinates();
      var mcb = new MonotoneChainIndexer();
      this.startIndex = mcb.getChainStartIndices(this.pts);
    }
  }]);
  return MonotoneChainEdge;
}();
export { MonotoneChainEdge as default };